import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAnsar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fillRule='evenodd' clipPath='url(#ansar_svg__a)' clipRule='evenodd'>
      <path
        fill='#EAB612'
        d='M3.508 15.497h16.956v4.977H3.508zM3.534 3.518h16.955v4.978H3.534z'
      />
      <path
        fill='#A71A20'
        d='M0 11.977 12.013 0l3.509 3.526L3.509 15.504zM8.479 20.474 20.49 8.497l3.51 3.526L11.987 24z'
      />
    </g>
    <defs>
      <clipPath id='ansar_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgAnsar)
export default ForwardRef
